<template>
    <div class="container mt-5">
        <company-editor id="companyEditor" :economicSectors="economicSectors" :policies="policies" :company="company" :qualificationGroups="qualificationGroups" :image-size="imageSize" />
    </div>
</template>

<style scoped></style>

<script>
import CompanyEditor from "@/Components/CompanyEditor.vue";
import ACPLayout from "@/Layouts/ACP";

export default {
    layout: ACPLayout,
    data: (instance) => {
        return {};
    },
    methods: {},
    components: { CompanyEditor },
    props: {
        qualificationGroups: Object,
        company: Object,
        policies: Object,
        economicSectors: Object,
        imageSize: Number,
    },
};
</script>
